import fetch from 'isomorphic-unfetch'
import { isProductionHost } from 'lib/env'

export const footerWidgetSlotId = '5577dbe2b922930e0c000022'
export const sammioSlotId = '58befea1b92293619c000003'
export const almaForgottenPasswordURI = isProductionHost() ? 'https://itsepalvelu.almamedia.fi/unohtunut-salasana' : 'https://itsepalvelu.tunnus-dev.almamedia.net/unohtunut-salasana'

const ALMA_CONTENT_ROUTER_URL = 'https://almacrcommoncontent.net'

export const ALMA_AUTH0_DOMAIN = isProductionHost() ? 'tunnus.almamedia.fi' : 'tunnus-dev.almamedia.net'
export const ALMA_AUTH0_AUDIENCE = isProductionHost() ? 'https://tunnus.almamedia.fi' : 'https://tunnus-dev.almamedia.net'
export const ALMA_AUTH0_CLIENT_ID = isProductionHost() ? process.env.PROD_AUTH0_CLIENT_ID : process.env.AUTH0_CLIENT_ID
export const ALMA_AUTH0_LOGIN_CALLBACK_URL = `${window.location.origin}/login/callback`
export const ALMA_AUTH0_LOGOUT_CALLBACK_URL = `${window.location.origin}/logout/callback`

export const USL = Object.freeze({
    SOURCE: {
        navigation_topmenu_login: 'navigation_topmenu_login',
        own_vehicle_login: 'own_vehicle_login',
        own_vehicle_register: 'own_vehicle_register',
        financing_application_login: 'financing_application_login',
        financing_application_register: 'financing_application_register',
        digital_bill_of_sale_start_digital_sale: 'digital_bill_of_sale_start_digital_sale',
        digital_bill_of_sale_start_purchase: 'digital_bill_of_sale_start_purchase',
        seller_logs_in_after_receiving_offer: 'seller_logs_in_after_receiving_offer',
        seller_registers_after_receiving_offer: 'seller_registers_after_receiving_offer',
        buyer_logs_in_after_signing_contract: 'buyer_logs_in_after_signing_contract',
        buyer_registers_after_signing_contract: 'buyer_registers_after_signing_contract',
        see_contract_other_person_logs_in_after_sale: 'see_contract_other_person_logs_in_after_sale',
        see_contract_other_person_registers_after_sale: 'see_contract_other_person_registers_after_sale',
        financing_login: 'financing_login',
        verify_email_login: 'verify_email_login',
    },
    TYPE: {
        permanent: 'Permanent',
        content_related: 'Content-related',
    },
})

// Fetch Alma widget via Alma Content Router and append it to the document
// https://github.com/almamedia/content-router-client#vanillajs-es6-example-for-transpilation
export const getSlot = (slotID) => {
    const url = `${ALMA_CONTENT_ROUTER_URL}/${slotID}`
    fetch(url)
        .then((response) => response.text())
        .then((text) => {
            const targetElement = document.createElement('div')
            targetElement.innerHTML = text
            targetElement.setAttribute('id', `alma-content-router-target-${slotID}`)
            const scripts = Array.from(targetElement.getElementsByTagName('script'))
            document.body.appendChild(targetElement)
            scripts.forEach((script) => {
                Function(script.text)() // eslint-disable-line no-new-func
            })
        })
}
